import React from 'react';
import PropTypes from 'prop-types';

import OverlayModal from '../../../ContentSystem/components/OverlayModal/OverlayModal';
import AuthenticationBody from '../AuthenticationBody/AuthenticationBody';
import { STEPS, useAuthState } from '../../Authentication.context';

const { LOGIN, FORGOT, WELCOME } = STEPS;

const excludedPaths = new RegExp(
  ['/account', '/forgot-password'].join('|'),
  'i'
);

/**
 * A modal to allow users to complete an authentication flow
 */
const AuthenticationDialog = ({ onSuccess }) => {
  const {
    isDialogOpen,
    setIsDialogOpen,
    currentStep,
    setCurrentStep,
    resetFlow
  } = useAuthState();
  const isExcludedRoute = excludedPaths.test(window.location);

  if (isExcludedRoute) {
    return null;
  }

  const handleClose = () => {
    setIsDialogOpen(false);
    // reset the current step in the provider state for next time the modal is opened
    setTimeout(() => resetFlow(), 300);
  };

  return (
    <OverlayModal
      isPeeking
      withPadding={currentStep.id !== WELCOME.id}
      showHeaderBackButton={currentStep.id === FORGOT.id}
      onClickBackButton={() => {
        setCurrentStep(LOGIN);
      }}
      onRequestClose={handleClose}
      isOpen={isDialogOpen}
      header={currentStep.title}
      size="mini"
    >
      <AuthenticationBody
        onRequestClose={() => setIsDialogOpen(false)}
        onSuccess={onSuccess}
      />
    </OverlayModal>
  );
};

AuthenticationDialog.propTypes = {
  /**
   * optional call back to run on successful authentication
   * used to refresh checkout page
   */
  onSuccess: PropTypes.func
};

AuthenticationDialog.defaultProps = {
  onSuccess: undefined
};

export default AuthenticationDialog;
